<template>

    <div class="mr-0 md:mr-64 flex flex-row items-center">
        <!--<i class="material-icons mr-2 ml-2 cursor-pointer transform text-theme-discrete transition-all duration-200" :class="{ '-rotate-90': !dataIsVisible }" style="font-size: 32px;" @click="toggleDataIsVisible">arrow_drop_down</i>-->
        <i class="material-icons mr-2 -ml-2 cursor-pointer transform text-theme-discrete transition-all duration-200" :class="{ '-rotate-90': !dataIsVisible }" style="font-size: 32px;" @click="toggleDataIsVisible">arrow_drop_down</i>

        <h2 v-if="currentlocale==='es'" class="text-theme-discrete hover:text-theme-title cursor-pointer font-bold text-base md:text-xl" @click="toggleDataIsVisible">Ayudas para su Exploración</h2>
        <h2 v-else class="text-theme-discrete hover:text-theme-title cursor-pointer font-bold text-base md:text-xl" @click="toggleDataIsVisible">Exploration Helpers</h2>

        <i class="material-icons mr-2 ml-2 cursor-pointer transform text-theme-discrete transition-all duration-200" :class="{ 'rotate-90': !dataIsVisible }" style="font-size: 32px;" @click="toggleDataIsVisible">arrow_drop_down</i>
    </div>

</template>

<script>

    export default {

        props: [
            'currentlocale'
        ],

        data() {

            return {
                dataIsVisible: false,
            }

        },

        methods: {

            toggleDataIsVisible() {
                this.dataIsVisible = !this.dataIsVisible;
                Event.fire('toggleHelpersVisible');
            },

        }

    }

</script>
